import React, { useEffect, useState } from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
import {
    RebelCard,
    RebelSectionTitle,
    RebelButton,
    RebelSecondaryButton,
    RebelDangerButton,
    RebelGrid,
    RebelListItem,
    RebelIcon,
    RebelEmptyState,
    RebelLoadingSpinner,
    RebelRow,
    RebelCol,
    RebelModal,
    RebelModalHeader,
    RebelModalBody,
    RebelModalFooter
} from "../../../styles/rebel-experiences";
import { GetDB, generateGUID } from "../../../utils/database/firebase-budget-tool";
import { listenToCollection, setDocument, updateDocumentProperty, deleteDocument } from "../../../utils/firestore-functions";
import firebase from "firebase/compat/app";

const RebelVillaList = () => {
    const [villaList, setVillaList] = useState({});
    const [sortedList, setSortedList] = useState({});
    const [deleteID, setDeleteID] = useState("");
    const [loading, setLoading] = useState(true);

    const budgetDB = GetDB();

    const [currentPage, setCurrentPage] = useState(0);
    const [recordsPerPage] = useState(12);

    const nPages = Math.ceil(Object.entries(sortedList).length / recordsPerPage);

    useEffect(() => {
        var unsubscribe = listenToCollection(budgetDB, "rebelVillas", SetLists);
        return unsubscribe;
    }, []);

    const SetLists = (villas) => {
        let x = villas.reduce((accumulator, value) => {
            return { ...accumulator, [value.id]: value }
        }, {});
        setVillaList(x);
        setSortedList(Object.fromEntries(Object.entries(x).sort(function (a, b) {
            return b[1].lastModification - a[1].lastModification;
        })));
        setLoading(false);
    };

    const openVilla = (id) => {
        const timeStamp = firebase.firestore.Timestamp.now().toDate();
        updateDocumentProperty(budgetDB, "rebelVillas", id, "lastModification", timeStamp);
        window.location = "/budget-app/rebel-settings/edit/" + id;
    };

    const createNewVilla = () => {
        const newTitle = "Villa " + (Object.keys(villaList).length + 1);
        const timeStamp = firebase.firestore.Timestamp.now().toDate();

        let newVilla = {
            villaName: newTitle,
            location: "",
            lastModification: timeStamp,
            id: generateGUID(),
            destCurrency: "USD$",
            baseRate: 1,
            convertRate: 1,
            villaRentalFee: 0,
            cleaningFee: 0,
            flightCost: 0,
            costPerTransportation: 0,
            transportation: {},
            costPerActivity: 0,
            numActivities: 0,
            costPerBreakfast: 0,
            numBreakfast: 0,
            costPerLunch: 0,
            numLunch: 0,
            costPerDinner: 0,
            numDinner: 0,
            costPerCoffee: 0,
            numCoffee: 0,
            costPerAlcohol: 0,
            numAlcohol: 0,
            av: {value: 0, pp: "per day"},
            setupFee: {value: 0, pp: "per day"},
            roomRental: {value: 0, pp: "per day"},
            numMeetings: 0,
            miscellaneousCosts: [],
            notes: ""
        };

        const openNewVilla = () => {
            openVilla(newVilla.id);
        };

        setDocument(budgetDB, "rebelVillas", newVilla.id, newVilla, openNewVilla);
    };

    const deleteVilla = async (id) => {
        toggleDeleteModal();
        console.log("deleting " + deleteID);
        deleteDocument(budgetDB, "rebelVillas", deleteID);
    };

    const confirmDelete = (id) => {
        toggleDeleteModal();
        setDeleteID(id);
    };

    const [modal, setModal] = useState(false);
    const toggleDeleteModal = () => setModal(!modal);

    useEffect(() => {
        const handleKeyPress = (e) => {
            if (modal && e.key === 'Enter') {
                deleteVilla(deleteID);
            }
        };

        if (modal) {
            window.addEventListener('keydown', handleKeyPress);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [modal, deleteID]);

    const navigateToPage = (e, i) => {
        e.preventDefault();
        setCurrentPage(i);
    };

    if (loading) {
        return (
            <RebelCard>
                <div style={{ textAlign: 'center', padding: '48px' }}>
                    <RebelLoadingSpinner />
                    <p style={{ marginTop: '16px', color: '#b0b0b0' }}>Loading R.E.B.E.L Villas...</p>
                </div>
            </RebelCard>
        );
    }

    return (
        <React.Fragment>
            <RebelModal isOpen={modal} toggle={toggleDeleteModal}>
                <RebelModalHeader toggle={toggleDeleteModal}>
                    Delete R.E.B.E.L Villa?
                </RebelModalHeader>
                <RebelModalBody>
                    This action cannot be undone. All data associated with this villa will be permanently removed.
                </RebelModalBody>
                <RebelModalFooter>
                    <RebelSecondaryButton onClick={toggleDeleteModal}>
                        Cancel
                    </RebelSecondaryButton>
                    <RebelDangerButton onClick={() => deleteVilla(deleteID)}>
                        <RebelIcon icon={['fas', 'trash']} />
                        Delete Villa
                    </RebelDangerButton>
                </RebelModalFooter>
            </RebelModal>

            <RebelCard>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                    <RebelSectionTitle>
                        <RebelIcon icon={['fas', 'home']} />
                        Villa Properties
                    </RebelSectionTitle>
                    <RebelButton onClick={createNewVilla}>
                        <RebelIcon icon={['fas', 'plus']} />
                        Create New Villa
                    </RebelButton>
                </div>

                {Object.entries(sortedList).length === 0 ? (
                    <RebelEmptyState>
                        <RebelIcon icon={['fas', 'home']} style={{ fontSize: '3rem', marginBottom: '16px' }} />
                        <h3>No R.E.B.E.L Villas Yet</h3>
                        <p>Create your first villa property to get started.</p>
                        <RebelButton onClick={createNewVilla}>
                            <RebelIcon icon={['fas', 'plus']} />
                            Create Your First Villa
                        </RebelButton>
                    </RebelEmptyState>
                ) : (
                    <>
                        <RebelGrid>
                            {Object.entries(sortedList)
                                .slice(currentPage * recordsPerPage, (currentPage + 1) * recordsPerPage)
                                .map(([id, villa], i) => (
                                    <RebelListItem key={id}>
                                        <div style={{ marginBottom: '12px' }}>
                                            <h4 style={{ color: '#ffffff', marginBottom: '8px', fontSize: '1.1rem' }}>
                                                {villa.villaName}
                                            </h4>
                                            <p style={{ color: '#b0b0b0', fontSize: '0.9rem', margin: '0' }}>
                                                {villa.location && (
                                                    <>
                                                        <RebelIcon icon={['fas', 'map-marker-alt']} />
                                                        {villa.location}
                                                    </>
                                                )}
                                            </p>
                                            <p style={{ color: '#b0b0b0', fontSize: '0.85rem', margin: '4px 0 0 0' }}>
                                                Modified: {villa.lastModification ?
                                                    villa.lastModification.toDate().toLocaleDateString("en-US") :
                                                    'Unknown'
                                                }
                                            </p>
                                        </div>

                                        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                                            <RebelButton
                                                size="sm"
                                                onClick={() => openVilla(villa.id)}
                                                style={{ padding: '8px 16px', fontSize: '0.85rem' }}
                                            >
                                                <RebelIcon icon={['fas', 'edit']} />
                                                Edit
                                            </RebelButton>
                                            <RebelSecondaryButton
                                                size="sm"
                                                onClick={() => confirmDelete(villa.id)}
                                                style={{
                                                    padding: '8px 12px',
                                                    fontSize: '0.85rem',
                                                    border: '2px solid #dc3545',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    minWidth: '44px'
                                                }}
                                            >
                                                <RebelIcon icon={['fas', 'trash']} style={{marginRight: 0}} />
                                            </RebelSecondaryButton>
                                        </div>
                                    </RebelListItem>
                                ))}
                        </RebelGrid>

                        {nPages > 1 && (
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '32px' }}>
                                <Pagination>
                                    <PaginationItem disabled={currentPage <= 0}>
                                        <PaginationLink
                                            onClick={e => navigateToPage(e, 0)}
                                            first
                                            href="#"
                                        />
                                    </PaginationItem>
                                    <PaginationItem disabled={currentPage <= 0}>
                                        <PaginationLink
                                            onClick={e => navigateToPage(e, currentPage - 1)}
                                            href="#"
                                            previous
                                        />
                                    </PaginationItem>
                                    {[...Array(nPages)].map((page, i) =>
                                        <PaginationItem active={i === currentPage} key={i}>
                                            <PaginationLink
                                                active={i === currentPage}
                                                onClick={e => navigateToPage(e, i)}
                                                href="#"
                                            >
                                                {i + 1}
                                            </PaginationLink>
                                        </PaginationItem>
                                    )}
                                    <PaginationItem disabled={currentPage + 1 >= nPages}>
                                        <PaginationLink
                                            onClick={e => navigateToPage(e, currentPage + 1)}
                                            href="#"
                                            next
                                        />
                                    </PaginationItem>
                                    <PaginationItem disabled={currentPage + 1 >= nPages}>
                                        <PaginationLink
                                            onClick={e => navigateToPage(e, nPages - 1)}
                                            href="#"
                                            last
                                        />
                                    </PaginationItem>
                                </Pagination>
                            </div>
                        )}
                    </>
                )}
            </RebelCard>
        </React.Fragment>
    );
};

export default RebelVillaList;
